import { useMemo } from "react";
import { exportWord, exportExcel } from "../lib/exports";
import { triwulanLabel } from "../lib/constants";

export const ReportPreviewModal = ({ open, jobs = [], company = "", logoUrl = "", onClose }) => {
  const rows = useMemo(
    () => jobs.flatMap((j) => j.items.map((item) => ({ job: j, item }))),
    [jobs]
  );
  if (!open) return null;

  return (
    <div className="no-print fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl my-auto flex flex-col max-h-[92vh] animate-fade-up" data-testid="report-preview-modal">
        <div className="px-6 py-4 bg-slate-900 text-white flex justify-between items-center">
          <h3 className="text-base sm:text-lg font-bold flex items-center gap-2"><i className="ph-bold ph-file-magnifying-glass text-teal-400" /> Pratinjau Laporan</h3>
          <button onClick={onClose} className="text-slate-300 hover:text-white p-1 rounded-lg hover:bg-white/10" data-testid="report-preview-close"><i className="ph-bold ph-x text-xl" /></button>
        </div>

        <div className="px-6 py-3 border-b border-slate-200 flex items-center justify-between gap-3 flex-wrap">
          <div className="min-w-0">
            <p className="font-display text-slate-900 font-extrabold text-sm truncate">{company || "Laporan Pekerjaan Service"}</p>
            <p className="text-[11px] text-slate-500 font-semibold">{rows.length} baris item • {jobs.length} pekerjaan</p>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={() => exportWord(jobs, company, logoUrl)} disabled={!rows.length} className="inline-flex items-center gap-1.5 bg-blue-700 hover:bg-blue-800 text-white px-3 py-2 rounded-lg text-xs font-bold disabled:opacity-50" data-testid="preview-download-word"><i className="ph-bold ph-file-doc text-base" /> Unduh Word</button>
            <button onClick={() => exportExcel(jobs)} disabled={!rows.length} className="inline-flex items-center gap-1.5 bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-lg text-xs font-bold disabled:opacity-50" data-testid="preview-download-excel"><i className="ph-bold ph-file-xls text-base" /> Unduh Excel</button>
          </div>
        </div>

        <div className="p-4 sm:p-6 overflow-auto flex-1">
          {rows.length === 0 ? (
            <div className="py-16 text-center text-slate-400">
              <i className="ph-bold ph-clipboard-text text-4xl" />
              <p className="text-sm mt-2 font-semibold">Tidak ada data untuk ditampilkan.</p>
            </div>
          ) : (
            <table className="w-full border-collapse text-[11px]" data-testid="report-preview-table">
              <thead>
                <tr className="bg-slate-100 text-slate-700 text-left">
                  {["Gedung", "Lantai", "Ruang", "Kategori", "Kondisi", "Spesifikasi", "Pengerjaan", "Bahan", "Status", "Triwulan"].map((h) => (
                    <th key={h} className="border border-slate-300 px-2 py-1.5 font-bold uppercase tracking-wide text-[10px]">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map(({ job, item }, i) => (
                  <tr key={`${job.id}-${i}`} className="odd:bg-white even:bg-slate-50/60 align-top">
                    <td className="border border-slate-200 px-2 py-1.5 font-bold text-slate-800">{item.gedung || job.title}</td>
                    <td className="border border-slate-200 px-2 py-1.5">{item.lantai}</td>
                    <td className="border border-slate-200 px-2 py-1.5">{item.ruang}</td>
                    <td className="border border-slate-200 px-2 py-1.5">{item.kategori}</td>
                    <td className="border border-slate-200 px-2 py-1.5">{item.kondisi}</td>
                    <td className="border border-slate-200 px-2 py-1.5">{item.spesifikasi}</td>
                    <td className="border border-slate-200 px-2 py-1.5 text-slate-600">{item.detail}</td>
                    <td className="border border-slate-200 px-2 py-1.5 text-slate-600">{item.bahan}</td>
                    <td className="border border-slate-200 px-2 py-1.5 font-bold text-slate-800">{item.status}</td>
                    <td className="border border-slate-200 px-2 py-1.5 whitespace-nowrap">{triwulanLabel(job)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="px-6 py-4 border-t border-slate-200 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 border border-slate-300 text-slate-700 text-xs font-bold rounded-lg hover:bg-slate-50">Tutup</button>
        </div>
      </div>
    </div>
  );
};
